/**
 * 清理HTML内容并解码HTML实体
 *
 * @param html - HTML内容
 * @param options - 可选；配置选项；`options.trimEndNewline` 是否去除末尾换行，默认为 `true`
 */
export const cleanAndUnescapeHtml = (html: string, options = { trimEndNewline: true }): string => {
    let result = html
        .replace(/<br>|&nbsp;/g, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/\t/g, '\u3000\u3000'); // 将制表符替换为两个全角空格

    if (options.trimEndNewline) {
        result = result.replace(/\n$/, ''); // 移除末尾多余的换行符
    }

    return result;
};
